import type { ReactNode } from 'react';
import { Menu } from 'lucide-react';
import { Icon } from '@/shared/components/Icon';
import { cn } from '@/shared/helpers/cn';
import styles from './Topbar.module.scss';

export interface TopbarProps {
  /** Título da página. É o `<h1>` — um por página. */
  title: string;
  /**
   * Linha secundária, abaixo do título.
   *
   * Para quando o título nomeia a tela e falta dizer **que recorte dela** está
   * aberto — o tipo de visão da agenda, por exemplo. Sem ela, o título teria de
   * mudar junto com o recorte e a tela perderia o nome.
   */
  subtitle?: string;
  /** Botão de menu, visível abaixo de `md`. */
  onOpenMenu?: () => void;
  /** Ação colada ao título, à esquerda. É a ação principal da tela. */
  titleAction?: ReactNode;
  /** Ações globais, alinhadas à direita na mesma baseline do título. */
  actions?: ReactNode;
  className?: string;
}

/** Cabeçalho da página, alinhado com a primeira coluna da grade. */
export function Topbar({
  title,
  subtitle,
  onOpenMenu,
  titleAction,
  actions,
  className,
}: TopbarProps) {
  return (
    <header className={cn(styles.topbar, className)}>
      {onOpenMenu ? (
        <button type="button" className={styles.menu} onClick={onOpenMenu} aria-label="Abrir menu">
          <Icon as={Menu} size={20} />
        </button>
      ) : null}

      <div className={styles.titleGroup}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>

      {titleAction ? <div className={styles.titleAction}>{titleAction}</div> : null}

      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}
